/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateSupportAdminMessageDto
 */
export interface CreateSupportAdminMessageDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSupportAdminMessageDto
     */
    'body': string;
    /**
     * Status to move the ticket to alongside the reply, e.g. PENDING_CUSTOMER when the reply asks a question. Omit to leave the status alone.
     * @type {string}
     * @memberof CreateSupportAdminMessageDto
     */
    'status'?: CreateSupportAdminMessageDtoStatusEnum;
    /**
     * The stateToken from the ticket this message was written against. When present, the API refuses with 409 if the ticket changed in the meantime — which is how a reply to a question the merchant has since amended, or a duplicate of one a colleague already sent, is stopped before it leaves. Omit to send unconditionally.
     * @type {string}
     * @memberof CreateSupportAdminMessageDto
     */
    'expectedStateToken'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateSupportAdminMessageDtoStatusEnum {
    New = 'NEW',
    Open = 'OPEN',
    PendingCustomer = 'PENDING_CUSTOMER',
    UnderReview = 'UNDER_REVIEW',
    Planned = 'PLANNED',
    Declined = 'DECLINED',
    Resolved = 'RESOLVED',
    Closed = 'CLOSED'
}


